import { Select } from '@ardoq/select';
import { Operator } from '@ardoq/api-types';
import { TextInput } from '@ardoq/forms';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';
import { QueryBuilderFilterType } from '../../filterUtils';
import { getOperatorsIconName, getOperatorsLabel } from './utils';

type SelectOperatorProps = {
  operators: Operator[];
  selectedOperator?: Operator;
  filterType?: QueryBuilderFilterType;
  onValueChange: (operator?: Operator) => void;
  clickId?: string;
  inputId?: string;
  isDisabled?: boolean;
  menuPortalTarget?: HTMLElement | null;
  i18nLocale?: I18nLocale;
};

export const SelectOperator = ({
  operators,
  selectedOperator,
  onValueChange,
  filterType,
  clickId,
  inputId,
  isDisabled,
  menuPortalTarget,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: SelectOperatorProps) => {
  if (selectedOperator && operators.length < 2) {
    return (
      <TextInput
        isDisabled={isDisabled}
        isReadOnly
        value={getOperatorsLabel(selectedOperator, i18nLocale, filterType)}
      />
    );
  }
  return (
    <Select
      aria-label={t(i18nLocale, 'queryBuilder:ariaLabel.operator', 'Operator')}
      isDisabled={isDisabled}
      inputId={inputId}
      placeholder={t(
        i18nLocale,
        'queryBuilder:placeholder.selectOperator',
        'Select operator...'
      )}
      value={selectedOperator}
      onValueChange={newSelectedOperator => {
        onValueChange((newSelectedOperator as Operator) || undefined);
      }}
      options={operators.map(operator => ({
        iconName: getOperatorsIconName(operator),
        label: getOperatorsLabel(operator, i18nLocale, filterType),
        value: operator,
      }))}
      clickId={clickId}
      dataTestId="select-operator"
      menuPortalTarget={menuPortalTarget}
    />
  );
};
